import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18}>
    <g id="组件_9_1" data-name="组件 9 – 1" opacity="0.65" fill="currentColor">
      <rect id="矩形_1086" data-name="矩形 1086" width="18" height="18" fill="none" />
      <path
        id="交易明细"
        d="M193.923,179.2a2.672,2.672,0,0,1,2.677,2.667v12.667a2.672,2.672,0,0,1-2.677,2.667H181.877a2.672,2.672,0,0,1-2.677-2.667V181.867a2.672,2.672,0,0,1,2.677-2.667Zm-13.385,6v9.334a1.335,1.335,0,0,0,1.238,1.33l.1,0h12.046a1.336,1.336,0,0,0,1.335-1.233l0-.1V185.2H180.538Zm9.7,7a.667.667,0,1,1,0,1.333h-.669a.667.667,0,1,1,0-1.333Zm-3.346,0a.667.667,0,1,1,0,1.333h-4.015a.667.667,0,1,1,0-1.333Zm4.685-4a.667.667,0,1,1,0,1.333h-8.7a.667.667,0,1,1,0-1.333Zm2.342-7.667H181.877a1.336,1.336,0,0,0-1.335,1.233l0,.1v2h14.723v-2a1.335,1.335,0,0,0-1.238-1.33Z"
        transform="translate(-178.9 -179.2)"
      />
    </g>
  </svg>
);

export default CMP;
